export class TypeModel {
  name: string;
  code: string;

  constructor(){
    this.name = "";
    this.code = "";
  }
}
